export class ArrayHelper {
    /**
    * Given two arrays of objects it returns the element in the `compareArray` that are
    * different from the `sourceArray`.
    */
    static getObjectDifference(sourceArray: Array<any>, compareArray: Array<any>) {
        return sourceArray.filter(object1 => {
            return !compareArray.some(object2 => object1.id === object2.id);
        });
    }

    static sortArray(array: Array<any>, property: string): Array<any> {
        array.sort(this.sortBy(property));
        return array;
    }

    /**
    * Sort by any object property
    * @param property its the property required to be sort by
    * @returns sorted element
    */
    static sortBy<T, K extends keyof T>(property: K) {
        return (a: T, b: T): number => {
            const idA = a[property] as string;
            const idB = b[property] as string;
            if (idA && idB) {
                return idA.localeCompare(idB);
            } else if (!idA) {
                return 1;
            } else if (!idB) {
                return -1;
            }
            return 0;
        }
    }

    static pushToArray(object: any, key: string, toBePushed: any) {
        if (object[key]) {
            object[key] = [...toBePushed, ...object[key]];
        } else {
            object[key] = [...toBePushed];
        }
    }

}